.result {
    font-size: 100px;
}

.winner {
    color: green;
}

.loser {
    color: red;
}

.push {
    color: yellow;
}
